import React, { useEffect, useState } from 'react';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { Button, Col, Form, Input, Modal, Row, Spin, Table, TableColumnsType, Typography } from 'antd';
import Title from 'antd/es/typography/Title';
import { saveComplete, saveDraft } from 'app/entities/checkIn/checkIn.reducer';
import { displayPercent } from 'app/shared/util/percent';
import { Container } from 'reactstrap';
import { getKrConfirmComplete, reset } from 'app/entities/checkIn/checkIn-draft.reducer';
const { Text } = Typography;

type IConfirmCompleteDraftYearProps = {
  isOpen: boolean;
  onClose: (isReload?: boolean) => void;
};

export const ConfirmCompleteDraftYear = ({ isOpen, onClose }: IConfirmCompleteDraftYearProps) => {
  const dispatch = useAppDispatch();
  const [form] = Form.useForm();
  const filters = useAppSelector(state => state.filters.orgCheckIn);
  const updating = useAppSelector(state => state.checkIn.updating);
  const loading = useAppSelector(state => state.checkIn.loading);
  const updateSuccess = useAppSelector(state => state.checkIn.updateSuccess);

  const [data, setData] = useState(null);

  const columnsResult: TableColumnsType<any> = [
    {
      key: 'workStatusName',
      dataIndex: 'workStatusName',
      width: 200,
    },
    {
      title: 'Số KR',
      key: 'draftYearCount',
      align: 'center',
      dataIndex: 'draftYearCount',
    },
    {
      title: 'Tỷ lệ',
      key: 'draftYearProportion',
      align: 'center',
      dataIndex: 'draftYearProportion',
      render: item => {
        const value = displayPercent(item);
        return value === 0 ? '0%' : `${parseFloat(value.toFixed(2))}%`;
      },
    },
  ];

  useEffect(() => {
    if (filters?.planPeriodId) innitData();
  }, [filters]);

  const innitData = async () => {
    const response = await dispatch(
      getKrConfirmComplete({ planPeriodId: filters?.planPeriodId, checkinType: 1, partyId: filters?.accountableId }),
    );
    if (response && response.payload) {
      const result = response.payload as any;
      if (result.data) {
        setData(result.data);
        form.setFieldsValue({
          adjustmentNote: result.data.adjustmentNote,
          successNote: result.data.successNote,
          failNote: result.data.failNote,
          issue: result.data.issue,
          solution: result.data.solution,
        });
      }
    }
  };

  useEffect(() => {
    if (updateSuccess) {
      handleClose(updateSuccess);
    }
  }, [updateSuccess]);

  const handleSubmit = values => {
    (values.planPeriodId = filters?.planPeriodId),
      (values.reportScheduleId = data.reportScheduleId),
      (values.partyId = filters?.accountableId),
      dispatch(saveComplete(values));
  };

  const handleSaveDraft = () => {
    form.validateFields().then(values => {
      (values.planPeriodId = filters?.planPeriodId),
        (values.reportScheduleId = data.reportScheduleId),
        (values.partyId = filters?.accountableId),
        dispatch(saveDraft(values));
    }).catch(() => { return; });
  };

  const handleClose = (reload = false) => {
    onClose(reload);
    dispatch(reset())
  };

  return (
    <Modal
      width={1150}
      open={isOpen}
      footer={null}
      onCancel={() => {
        handleClose();
      }}
    >
      <Container className="form">
        <Spin spinning={loading} delay={300}>
          <Form size="large" form={form} onFinish={handleSubmit} layout="vertical">
            <Title level={3}>{`Tổng hợp kết quả thực hiện ${filters?.accountableName ? `- ${filters?.accountableName}` : ''}`}</Title>
            <Row>
              <Col>
                <Form.Item label="Kỳ báo cáo">
                  <Input disabled value={data?.reportScheduleName} />
                </Form.Item>
              </Col>
            </Row>
            <Row className='my-3'>
              <Col md={24}>
                <span className="fw-bold h5">KẾT QUẢ THỰC HIỆN MỤC TIÊU</span>
              </Col>
            </Row>
            <Row>
              <Col md={24}>
                <Table
                  pagination={false}
                  bordered
                  dataSource={data?.workLoads}
                  columns={columnsResult}
                  className="w-100"
                  rowClassName={(record, index) => {
                    return index === data?.workLoads.length - 1 ? 'fw-bold' : '';
                  }}
                />
              </Col>
            </Row>

            <Form.Item>
              <Row className="action mt-3" justify="end">
                {/* TODO: Form checkin ước thực hiện lại gọi lưu nháp giữa năm , nên sai logic*/
                /**
                 * Nếu gọi lưu nháp giữa năm thì sẽ lưu nháp cho toàn bộ KR giữa năm
                 * Nếu gọi xác nhận hoàn thành thì sẽ xác nhận hoàn thành cho toàn bộ KR giữa năm
                 * Nếu gọi hủy thì sẽ hủy cho toàn bộ KR giữa năm
                 * Nếu gọi lưu nháp giữa năm thì sẽ lưu nháp cho toàn bộ KR giữa năm
                 * Nếu gọi xác nhận hoàn thành thì sẽ xác nhận hoàn thành cho toàn bộ KR giữa năm
                 * Nếu gọi hủy thì sẽ hủy cho toàn bộ KR giữa năm
                 */}
                {/* <Col>
                  <Button
                    className="green"
                    onClick={() => {
                      handleSaveDraft();
                    }}
                    disabled={updating}
                  >
                    Lưu nháp
                  </Button>
                </Col> */}

                {/* <Col>
                  <Button type="primary" htmlType="submit" disabled={updating}>
                    Xác nhận hoàn thành
                  </Button>
                </Col> */}
                <Col>
                  <Button
                    onClick={() => {
                      handleClose();
                    }}
                  >
                    Hủy
                  </Button>
                </Col>
              </Row>
            </Form.Item>
          </Form>
        </Spin>
      </Container>
    </Modal>
  );
};

export default ConfirmCompleteDraftYear;
